import { Step } from "../show";

const FinishedStep: Step = () => <p>Bedankt voor je feedback!</p>;

export default FinishedStep;
